export const ROUTES = {
  home: '/',
  shop: '/shop',
  blog: '/blog',
  podcast: '/podcast',
  about: '/about',
  authors: '/authors',
  books: '/books',
  titles: '/titles',
  luminaPress: '/pricing',
  cart: '/cart',
  account: '/account',
  accountLibrary: '/account/library',
  accountNotebook: '/account/notebook',
  accountDownloads: '/account/downloads',
  accountSaved: '/account/saved',
  accountOrders: '/account/orders',
  accountProfile: '/account/profile',
  accountAssessment: '/account/assessment',
  accountSecurity: '/account/security',
  accountSubscription: '/account/subscription',
  accountBilling: '/account/billing',
  accountSupport: '/account/support',
  accountNotifications: '/account/notifications',
  accountAffiliate: '/account/affiliate',
  ownerSeed: '/account/owner-seed',
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  completeProfile: '/complete-profile',
  stats: '/stats',
  assessment: '/assessment',
  assessmentPrivacy: '/assessment/privacy',
  studio: '/studio',
  studioProjects: '/studio/projects',
  studioNewProject: '/studio/projects/new',
  studioTemplates: '/studio/templates',
  studioCommunity: '/studio/community',
  studioSettings: '/studio/settings',
  admin: '/admin',
  adminUsers: '/admin/users',
  adminAssessments: '/admin/assessments',
  adminResearch: '/admin/assessments/research',
  adminAuthors: '/admin/authors',
  adminProjects: '/admin/projects',
  adminTitles: '/admin/titles',
  adminOrders: '/admin/orders',
  adminPayouts: '/admin/payouts',
  adminPromotions: '/admin/promotions',
  adminDiscounts: '/admin/discounts',
  adminFlags: '/admin/flags',
  adminReviews: '/admin/reviews',
  adminSubscriptions: '/admin/subscriptions',
  adminAiUsage: '/admin/ai-usage',
  adminStorage: '/admin/storage',
  adminSettings: '/admin/settings',
  adminStorefront: '/admin/storefront',
  adminCollections: '/admin/collections',
  adminTemplates: '/admin/templates',
  adminAnalytics: '/admin/analytics',
  adminAudit: '/admin/audit',
  adminBlog: '/admin/blog',
  adminHomepage: '/admin/homepage',
  adminFunnels: '/admin/funnels',
  adminPodcasts: '/admin/podcasts',
  adminMusic: '/admin/music',
  faq: '/faq',
  shipping: '/shipping',
  contact: '/contact',
  privacy: '/privacy',
  terms: '/terms',
  refundPolicy: '/refund-policy',
  access: '/access',
  firstChapter: '/first-chapter',
  checkout: '/checkout',
  checkoutSuccess: '/checkout/success',
  checkoutCancel: '/checkout/cancel',
  collections: '/collections',
  pricing: '/pricing',
  affiliates: '/affiliates',
} as const;

export const PUBLIC_HEADER_LINKS = [
  { href: ROUTES.shop, label: 'Shop' },
  { href: ROUTES.podcast, label: 'Podcast' },
  { href: ROUTES.blog, label: 'The Blog' },
  { href: ROUTES.about, label: 'About' },
  { href: ROUTES.pricing, label: 'Lumina Press' },
] as const;

export const ACCOUNT_NAV_LINKS = [
  { href: ROUTES.account, label: 'Overview' },
  { href: ROUTES.accountLibrary, label: 'Library' },
  { href: ROUTES.accountNotebook, label: 'Notebook' },
  { href: ROUTES.accountDownloads, label: 'Downloads' },
  { href: ROUTES.accountSaved, label: 'Saved' },
  { href: ROUTES.accountOrders, label: 'Orders' },
  { href: ROUTES.accountProfile, label: 'Profile' },
  { href: ROUTES.accountAssessment, label: 'Pattern profile' },
  { href: ROUTES.accountSecurity, label: 'Security' },
  { href: ROUTES.accountSubscription, label: 'Subscription' },
  { href: ROUTES.accountBilling, label: 'Billing' },
  { href: ROUTES.accountSupport, label: 'Support' },
  { href: ROUTES.accountNotifications, label: 'Notifications' },
  { href: ROUTES.accountAffiliate, label: 'Affiliate & referrals' },
] as const;

export const STUDIO_NAV_LINKS = [
  { href: ROUTES.studio, label: 'Dashboard' },
  { href: ROUTES.studioProjects, label: 'Projects' },
  { href: ROUTES.studioNewProject, label: 'New Project' },
  { href: ROUTES.studioTemplates, label: 'Templates' },
  { href: ROUTES.studioCommunity, label: 'Community' },
  { href: ROUTES.studioSettings, label: 'Settings' },
] as const;

export const ADMIN_NAV_LINKS = [
  { href: ROUTES.admin, label: 'Overview' },
  { href: ROUTES.adminUsers, label: 'Users' },
  { href: ROUTES.adminAssessments, label: 'Assessments' },
  { href: ROUTES.adminResearch, label: 'Research & Stats' },
  { href: ROUTES.adminProjects, label: 'Projects' },
  { href: ROUTES.adminTitles, label: 'Titles' },
  { href: ROUTES.adminStorefront, label: 'Storefront' },
  { href: ROUTES.adminOrders, label: 'Orders' },
  { href: ROUTES.adminPayouts, label: 'Payouts' },
  { href: ROUTES.adminPromotions, label: 'Promotions' },
  { href: ROUTES.adminDiscounts, label: 'Discounts' },
  { href: ROUTES.adminFlags, label: 'Flags' },
  { href: ROUTES.adminReviews, label: 'Reviews' },
  { href: ROUTES.adminSubscriptions, label: 'Subscriptions' },
  { href: ROUTES.adminAiUsage, label: 'AI Usage' },
  { href: ROUTES.adminStorage, label: 'Storage' },
  { href: ROUTES.adminSettings, label: 'Settings' },
  { href: ROUTES.adminCollections, label: 'Collections' },
  { href: ROUTES.adminTemplates, label: 'Templates' },
  { href: ROUTES.adminAnalytics, label: 'Analytics' },
  { href: ROUTES.adminAudit, label: 'Audit Log' },
  { href: ROUTES.adminBlog, label: 'Blog' },
  { href: ROUTES.adminHomepage, label: 'Homepage' },
  { href: ROUTES.adminFunnels, label: 'Funnels' },
  { href: ROUTES.adminPodcasts, label: 'Podcasts' },
  { href: ROUTES.adminMusic, label: 'Music' },
] as const;
